import React, { useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Hero.css";

export default function Hero() {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <section className="hero-section text-white" id="home">
      {/* Trade Pattern Background */}
      <div className="trade-pattern"></div>
      
      {/* SVG Animated Lines */}
      <svg className="trade-lines" viewBox="0 0 1440 500">
        <path d="M0,200 Q360,100 720,200 T1440,200" stroke="#3BAFDA" strokeWidth="2" fill="none">
          <animate attributeName="stroke-dasharray" from="0,1000" to="1000,0" dur="4s" repeatCount="indefinite" />
        </path>
        <circle r="6" fill="#FFD700">
          <animateMotion dur="6s" repeatCount="indefinite" path="M0,200 Q360,100 720,200 T1440,200" />
        </circle>
      </svg>

      {/* Overlay */}
      <div className="overlay"></div>

      {/* Content */}
      <Container className="text-center hero-content" data-aos="fade-up">
        <h1 className="hero-title" data-aos="zoom-in">Connecting the World Through Trade</h1>
        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
          Reliable Import & Export Solutions — VHATrade
        </p>
        <Button variant="warning" size="lg" className="me-3" data-aos="fade-right" data-aos-delay="400">
          Get Started
        </Button>
        <Button variant="light" size="lg" href="#services" data-aos="fade-left" data-aos-delay="400">
          Learn More
        </Button>
      </Container>
    </section>
  );
}

